import { getSegmentIndices, ISegmentDetail, pimImageToMediaProps, pimImageToOpenGraphImage } from '@viabizzuno/models';
import { getLayout } from '@viabizzuno/models/server';
import { LayoutDefault } from '@viabizzuno/ui';
import { getPageProps } from '@viabizzuno/ui/server';
import { asEquatable, IStaticContext, PageProps } from '@websolutespa/bom-core';
import { getLabel, getPage, getStaticPathsForSchema } from '@websolutespa/bom-mixer-models/server';
import { LazyLoader, OpenGraph, StructuredData } from '@websolutespa/bom-mixer-ui';
import { BreadcrumbStructuredData } from '@viabizzuno/ui';

export default function SegmentDetail({ layout, page, params }: PageProps<ISegmentDetail>) {
  return (
    <>
      <LazyLoader components={page.components} />
      <StructuredData />
      <BreadcrumbStructuredData />
      <OpenGraph item={(metaData) => ({
        ...metaData.openGraph,
        image: page.mediaPicture ? pimImageToOpenGraphImage(page.mediaPicture) : undefined,
      })} />
    </>
  );
}

SegmentDetail.Layout = LayoutDefault;

export async function getStaticProps(context: IStaticContext) {
  const id = asEquatable(context.params.id);
  const market = context.params.market;
  const locale = context.params.locale;
  const layout = await getLayout(market, locale);
  const page = await getPage<ISegmentDetail>('segment_detail', id, market, locale);
  if (!page) {
    return {
      notFound: true,
      revalidate: true,
    };
  }

  const listing = await getSegmentIndices({ market, locale, limit: 1, sort: 'createdat' });
  const lbl = await getLabel('segments.back_to_listing', { market, locale });

  const components = page.components || [];

  page.components = [
    {
      schema: 'block_segment_intro',
      title: page.title,
      backlink: {
        href: listing.length > 0 ? listing[0].href : '',
        title: lbl ? lbl.text : 'torna al listing',
        type: 'link',
      },
      paragraph1: page.paragraph1,
      paragraph2: page.paragraph2,
      color: page.color,
      media: pimImageToMediaProps(page.mediaPicture),
      cover: pimImageToMediaProps(page.mediaSketch),
    },
    ...components,
  ];


  const props = await getPageProps({ ...context, layout, page });
  return {
    props,
    revalidate: 60 * 60 * 2, // revalidate
  };
}

export async function getStaticPaths() {
  const paths = await getStaticPathsForSchema('segment_detail');
  return {
    paths,
    fallback: 'blocking', // runs before initial render
    // fallback: true, // runs in the background
  };
}
